import { Select, useMediaQuery } from "@mui/material";
import { theme } from "../utilities/themes";

const DropDown = ({ children, value, onChange, sx, multiple = false }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Select
      value={value}
      onChange={onChange}
      sx={{
        boxShadow: {
          sm: "0px 1.5px 3px #aaaaaa",
          xs: "none",
        },
        borderRadius: "300px",
        fontSize: {
          sm: "16px",
          xs: "14px",
        },
        height: {
          sm: "5vh",
          xs: "4vh",
        },
        ...sx,
      }}
      variant={isMobile ? "standard" : "outlined"}
      multiple={multiple}
      size="small"
      renderValue={multiple ? (selected) => selected.join(", ") : null}
    >
      {children}
    </Select>
  );
};
export default DropDown;
